// Port of api/fuel/app/classes/filter/search/games/sorts/post/play/plays/users.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

export default {
	name: 'post.sort.play.plays.users',
	post: true,
	sorts: function(config) {
		return config.resultType === F.RESULT_GAME ? ['plays.users'] : []
	},
	modifies: function() {
		return 'index'
	},
	require: function(config, filter) {
		return config.ownerType !== F.OWNER_USER && config.resultType === F.RESULT_GAME && sorted('plays.users', filter) > 0
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results

		var sql = 'SELECT game_id, COUNT(DISTINCT user_id) as cnt FROM play WHERE game_id IN(' + Util.in(results.games) + ') AND user_id IN(' + Util.in(data.users) + ')'
		if (results.concat && results.concat.p && results.concat.p.length) {
			sql += ' AND play_id IN(' + Util.in(results.concat.p) + ')'
		}
		sql += ' GROUP BY game_id'

		var rows = DB.query(sql)
		var counts = Util.associated(rows, 'game_id', 'cnt')
		var reverse = sortReverse('plays.users', filter)

		results.games.sort(function(a, b) {
			var ca = parseInt(counts[a] || 0), cb = parseInt(counts[b] || 0)
			return reverse ? cb - ca : ca - cb
		})

		var gameOrder = {}
		for (var i = 0; i < results.games.length; i++) gameOrder[results.games[i]] = i
		results.index.sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga] || 0) - (gameOrder[gb] || 0)
		})

		return results
	}
}
